import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigLoaderService } from '../../Shared/Services/Config/config-loader.service';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageNotFoundComponent implements OnInit {
  HomePageUrl!:string;

  constructor(
    public router: Router
  ) { }

  ngOnInit(): void {
    this.HomePageUrl=ConfigLoaderService.settings.AppSettings.HomePageUrl;


  }

}
